<div class="row rounded-card" id="settings-table-columns">
  <div class="flex flex-wrap justify-between items-end mb-4" id="setting-view-header-wr">
    <div class="flex flex-col">
      <h2 data-testid="exports-settings-title">
        {{ 'SYSTEM_SETTINGS.MODULES.TABLES_COLUMNS_SETTINGS_TITLE' | translate }}
      </h2>
    </div>

    <div class="flex flex-col col-12">
      <span data-testid="exports-settings-subtitle" class="block text-base">
        {{ 'SYSTEM_SETTINGS.MODULES.TABLES_COLUMNS_SETTINGS_SUBTITLE' | translate }}
      </span>
    </div>
  </div>

  <hr class="w-full mb-1 mt-2 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-sales-title">
      {{ 'SYSTEM_SETTINGS.MODULES.SALES_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.SalesTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'sales-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="salesValues" />
        <label [for]="'sales-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-retailers-title">
      {{ 'SYSTEM_SETTINGS.MODULES.RETAILERS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.RetailsTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'retailers-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="retailsValues" />
        <label [for]="'retailers-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-retailerattributes-title">
      {{ 'SYSTEM_SETTINGS.MODULES.RETAILER_ATTRIBUTES_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.RetailerAttributeDefinitionsTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2">
      @if (column.field !== 'Actions') {
      <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'retailer-attributes-column-' + i"
        name="modules-columns" [value]="column.field" [(ngModel)]="retailerAttributesValues" />
      <label [for]="'retailer-attributes-column-' + i">{{ column.header }}</label>
      }
    </div>
  }


  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-retailertypes-title">
      {{ 'SYSTEM_SETTINGS.MODULES.RETAILER_TYPES_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.RetailerTypesTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [inputId]="'retailer-types-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="retailerTypesValues" />
        <label [for]="'retailer-types-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-warranties-title">
      {{ 'SYSTEM_SETTINGS.MODULES.WARRANTIES_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.WarrantiesTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'warranties-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="warrantiesValues" />
        <label [for]="'warranties-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-orders-title">
      {{ 'SYSTEM_SETTINGS.MODULES.CODE_ORDERS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.CodeOrdersTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'code-orders-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="codeOrdersValues" />
        <label [for]="'code-orders-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-products-title">
      {{ 'SYSTEM_SETTINGS.MODULES.PRODUCTS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.ProductsTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'products-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="productsValues" />
        <label [for]="'products-column-' + i">{{ column.header }}</label>
      }
    </div>
  }


  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-producttypes-title">
      {{ 'SYSTEM_SETTINGS.MODULES.PRODUCT_TYPES_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.ProductTypesTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'product-types-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="productTypesValues" />
        <label [for]="'product-types-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-productattributes-title">
      {{ 'SYSTEM_SETTINGS.MODULES.PRODUCT_ATTRIBUTES_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.ProductAttributeDefinitionsTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'product-attributes-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="productAttributesValues" />
        <label [for]="'product-attributes-column-' + i">
          {{ column.header }}
        </label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-items-title">
      {{ 'SYSTEM_SETTINGS.MODULES.ITEMS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.ItemsTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'items-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="itemsValues" />
        <label [for]="'items-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-inventories-title">
      {{ 'SYSTEM_SETTINGS.MODULES.INVENTORY_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.InventoriesTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'inventories-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="inventoriesValues" />
        <label [for]="'inventories-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-shipments-title">
      {{ 'SYSTEM_SETTINGS.MODULES.SHIPMENTS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.ShipmentsTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'shipments-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="shipmentsValues" />
        <label [for]="'shipments-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-customers-title">
      {{ 'SYSTEM_SETTINGS.MODULES.CUSTOMERS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.CustomersTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'customers-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="customersValues" />
        <label [for]="'customers-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-users-title">
      {{ 'SYSTEM_SETTINGS.MODULES.USERS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.UsersTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [inputId]="'users-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="usersValues" />
        <label [for]="'users-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-categories-title">
      {{ 'SYSTEM_SETTINGS.MODULES.CATEGORIES_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.CategoriesTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'categories-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="categorieValues" />
        <label [for]="'categories-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-cardorders-title">
      {{ 'SYSTEM_SETTINGS.MODULES.CARD_ORDER_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.CardOrdersTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'card-orders-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="cardOrdersValues" />
        <label [for]="'card-orders-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-collections-title">
      {{ 'SYSTEM_SETTINGS.MODULES.COLLECTIONS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.CollectionsTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'collections-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="collectionsValues" />
        <label [for]="'collections-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-distributionchannels-title">
      {{ 'SYSTEM_SETTINGS.MODULES.DISTRIBUTION_CHANNEL_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.DistributionChannelsTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'distribution-channels-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="distributionChannelsValues" />
        <label [for]="'distribution-channels-column-' + i">
          {{ column.header }}
        </label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-markets-title">
      {{ 'SYSTEM_SETTINGS.MODULES.MARKETS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.MarketsTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'markets-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="marketsValues" />
        <label [for]="'markets-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-imports-title">
      {{ 'SYSTEM_SETTINGS.MODULES.IMPORTS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.ImportsTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'imports-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="importsValues" />
        <label [for]="'imports-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-exports-title">
      {{ 'SYSTEM_SETTINGS.MODULES.EXPORTS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.ExportsTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      @if (column.field !== 'Actions') {
        <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'exports-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="exportsValues" />
        <label [for]="'exports-column-' + i">{{ column.header }}</label>
      }
    </div>
  }

  <div class="col-12 mt-6 mb-4 pt-8 border-t">
    <div class="flex items-center justify-end gap-3">
      <button data-testid="update-table-settings-btn" class="btn primary-btn" (click)="updateModulesSettings()">
        {{ 'SYSTEM_SETTINGS.MODULES.SAVE_TABLES_COLUMNS_CHANGES' | translate }}
      </button>
    </div>
  </div>
</div>
